import { formatDate } from '@angular/common';
import { Component, HostBinding, HostListener, OnInit } from '@angular/core';
import { CalendarDateFormatter, CalendarEvent, CalendarView, DateFormatterParams } from 'angular-calendar';
import { MonthViewDay } from 'calendar-utils';
import { IndexService, CardSize } from '../index.service';

export class CustomDateFormatter extends CalendarDateFormatter {
	public monthViewColumnHeader({ date, locale }: DateFormatterParams): string {
		// console.log(formatDate(date, 'EEEEE', locale));
		// switch (date.getDay()) {
		// 	case 0:
		// 		return 'S';
		// 		break;
		// 	case 1:
		// 		return 'M';
		// 		break;
		// 	case 2:
		// 		return 'T';
		// 		break;
		// 	case 3:
		// 		return 'W';
		// 		break;
		// 	case 4:
		// 		return 'T';
		// 		break;
		// 	case 5:
		// 		return 'F';
		// 		break;
		// 	case 6:
		// 		return 'S';
		// 		break;
		// }
		return formatDate(date, 'EEEEE', locale); // use short week days
	}
}
@Component({
	selector: 'common-calendar',
	templateUrl: './calendar.component.html',
	styleUrls: ['./calendar.component.scss'],
	providers: [
		{
			provide: CalendarDateFormatter,
			useClass: CustomDateFormatter
		}
	]
})
export class CalendarComponent implements OnInit {
	@HostBinding('class.c-index-calendar') hostClass = true;
	navName = 'calendar';
	navSize: CardSize;

	view: CalendarView = CalendarView.Month;
	viewDate = new Date();

	public innerWidth: any;
	modalData: {
		action: string;
		event: CalendarEvent;
	};

	showDay: MonthViewDay<any>;
	isEdit = false;
	activeDayIsOpen = true;
	editText: string;
	disX: number;
	disY: number;
	showDayHint = false;

	isEventsEmpty: boolean;

	@HostListener('document:click')
	closeShowDayHint() {
		this.showDayHint = false;
	}
	get events(): CalendarEvent[] {
		if (this.svr.userDiary) {
			return this.svr.userDiary.map(v => ({
				start: new Date(v.Day),
				title: v.Content
			}));
		}
		return [];
	}

	constructor(public svr: IndexService) {
		this.navSize = this.svr.userSetting.Cards.find(x => x.Type === this.navName).Size;
		// console.log(this.navSize);
	}
	handleEvent(action: string, event: CalendarEvent): void {
		// 111;
		console.log(action, event);
	}
	ngOnInit() {
		this.svr.initCalendar();
	}

	// âåå»æ¥ææ¶
	dayClick(event: { day: MonthViewDay<any>; sourceEvent: MouseEvent }) {
		// console.log((event.sourceEvent.target as HTMLElement).getBoundingClientRect());
		this.showDay = event.day;
		this.isEdit = !this.showDay.isPast && this.showDay.events.length === 0;
		this.showDayHint = true; // æ¥æå¤æ³¨æ¯å¦æ¾ç¤º
		// â è·åå¤æ³¨ä¿¡æ¯æ çåæ ï¼å³ ç¹å»åç´ å¨å±å¹ä¸­çä½ç½®ï¼
		const posCircle = (event.sourceEvent.target as HTMLElement).getBoundingClientRect();
		const distanceWidth = posCircle.width;
		const distanceRight = posCircle.right;
		// å¦æå³ä¾§è·ç¦»ä¸å¤ï¼åå¾éæ©å·¦ä¾§æ¾ç¤º
		if (window.innerWidth - distanceRight < 320) {
			this.disX = posCircle.left - 320 + 32;
		} else {
			this.disX = posCircle.left + distanceWidth - 32;
		}
		this.disY = posCircle.bottom;

		if (event.day.events && event.day.events.length > 0) {
			this.editText = event.day.events[0].title;
		} else {
			this.editText = '';
		}

		// console.log((this.innerWidth = window.innerWidth));
		// console.log('showDay:', this.showDay);
		// console.log('---');
		// console.log('showDay:', this.showDay.isPast);
	}
	editOk() {
		this.svr.updateUserDiary(this.showDay.date, this.editText).subscribe(() => {
			this.showDayHint = false;
		});
	}
	editCancel() {
		this.editText === '' ? (this.showDayHint = false) : (this.isEdit = false);
	}
	removeEvents() {
		this.svr.removeUserDiary(this.showDay.date).subscribe(() => {
			this.showDayHint = false;
		});
	}
}
